import React from 'react';
import styles from './IconButton.module.scss';

function IconButton({ count, icon, onClick, className, 'aria-label': ariaLabel, disabled }) {
  return (
    <button
      className={`${styles.iconButton}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {count !== undefined && count}
      {icon}
    </button>
  );
}

export default IconButton;
